module.exports = __webpack_public_path__ + "static/media/imprint-en.8b5267db.md";